import axios from "axios";
import { ChangeEvent, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegImages } from "react-icons/fa6";
import { IoReaderSharp } from "react-icons/io5";
import { FaCirclePlus } from "react-icons/fa6";

type UploadStatus = "idle" | "uploading" | "success" | "error";

const FileUploader = () => {
    const [files, setFiles] = useState<File[]>([]);
    const [status, setStatus] = useState<UploadStatus>('idle');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showUploader, setShowUploader] = useState(false);
    const [category, setCategory] = useState<string>("general");
    const [title, setTitle] = useState("");
    const [section2, setSection2] = useState([{ section: "", content: "" }]);

    const navigate = useNavigate();
    const inputRef = useRef<HTMLInputElement | null>(null);

    // 追加関数
    const addSection = () => {
        setSection2(prev => [...prev, { section: "", content: "" }]);
    };

    // 変更関数
    const updateSection = (index: number, field: "section" | "content", value: string) => {
        setSection2(prev => prev.map((s, i) => i === index ? { ...s, [field]: value } : s));
    };
    async function handleSubmit() {
        setStatus("uploading");
        try {
            await axios.post("/api/lessons/text", {
                title,
                section2,
                category,
            });
            setStatus("success");
            navigate("/manager/dashboard/lessons/library");
        } catch (err) {
            console.error(err);
            setStatus("error");
        }
    }

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            setFiles(prev => [...prev, ...newFiles]);
            // reset input so same file can be re-selected later
            if (inputRef.current) inputRef.current.value = "";
        }
    }

    async function handleFileUpload() {
        if (files.length === 0) return;
        setStatus("uploading");
        setUploadProgress(0);

        const formData = new FormData();
        // append all selected files under the same field name 'file'
        files.forEach((f) => formData.append('file', f));
        formData.append("category", category);

        try {
            // do NOT set the Content-Type header manually when sending FormData;
            // the browser will set the correct multipart boundary.
            await axios.post("/upload/lesson", formData, {
                onUploadProgress: (ProgressEvent) => {
                    const progress = ProgressEvent.total ?
                        Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total)
                        : 0;
                    setUploadProgress(progress);
                }
            });
            setStatus("success");
            setUploadProgress(100);
            // navigate to lesson library after successful upload (nav uses /library)
            navigate("/manager/dashboard/lessons/library");
        } catch (err) {
            console.error('Upload error', err);
            setStatus("error");
            setUploadProgress(0);
        }
    }

    return (
        <>
            <div className="upload-wrapper">
                <div className="select-training">
                    <label>
                        <input
                            type="radio"
                            value="general"
                            checked={category === "general"}
                            onChange={e => setCategory(e.target.value)}
                        />
                        General Training
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="positional"
                            checked={category === "positional"}
                            onChange={e => setCategory(e.target.value)}
                        />
                        Positional Training
                    </label>
                </div>
                <div className="upload-inner">
                    {/* hidden input always available for adding files */}
                    {/* <input ref={inputRef} type="file" onChange={handleFileChange} style={{ display: "none" }} multiple />

                        {files.length === 0 ? (
                            <div onClick={() => inputRef.current?.click()} style={{ cursor: 'pointer' }}>
                                <FaRegImages className="img-icon" style={{ color: "lightgray" }} />
                                <p><span style={{ fontWeight: "bold" }}>Click to upload</span> or drag and drop</p>
                                <p style={{ color: "lightgray" }}>PDF, MP4, PNG less than 5MB</p>
                            </div>
                        ) : (
                            <ul>
                                <IoReaderSharp className="img-icon" />
                                {files.map((f, i) => (
                                    <li key={i}>{f.name} — {(f.size / 1024).toFixed(2)} KB</li>
                                ))}
                                <button type="button"
                                    onClick={() => inputRef.current?.click()}
                                    style={{ marginLeft: 12 }}
                                    className="add-more">
                                    Add more
                                </button>
                            </ul>
                        )} */}
                    <label>
                        Add title
                        <input
                            placeholder="Input title"
                            value={title}
                            onChange={e => setTitle(e.target.value)}
                        />
                    </label>
                    <div className="content-inner">
                        {section2.map((s, i) => (
                            <div key={i}>
                                <label>
                                    Add section
                                    <input
                                        placeholder="Input section"
                                        value={s.section}
                                        onChange={e => updateSection(i, "section", e.target.value)}
                                    />
                                </label>
                                <label>
                                    Add content
                                    <input
                                        placeholder="content"
                                        value={s.content}
                                        onChange={e => updateSection(i, "content", e.target.value)}
                                        className="content"
                                    />
                                </label>
                            </div>
                        ))}
                        <p onClick={() => setShowUploader(prev => !prev)}
                            style={{ cursor: "pointer" }}
                        >
                            <FaCirclePlus /> add image/ file
                        </p>

                        {/* showUploaderがtrueのときだけ表示 */}
                        {showUploader && (
                            <div className="upload-file">
                                <input ref={inputRef} type="file" onChange={handleFileChange} style={{ display: "none" }} multiple />
                                {files.length === 0 ? (
                                    <div onClick={() => inputRef.current?.click()} style={{ cursor: 'pointer' }}>
                                        <FaRegImages className="img-icon" style={{ color: "lightgray" }} />
                                        <p><span style={{ fontWeight: "bold" }}>Click to upload</span> or drag and drop</p>
                                        <p style={{ color: "lightgray" }}>PDF, MP4, PNG less than 5MB</p>
                                    </div>
                                ) : (
                                    <ul>
                                        <IoReaderSharp className="img-icon" />
                                        {files.map((f, i) => (
                                            <li key={i}>{f.name} — {(f.size / 1024).toFixed(2)} KB</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                        <button type="button"
                            onClick={addSection}
                            className="add-more">
                            <FaCirclePlus /> Add more contents
                        </button>
                    </div>
                </div>
                <button
                    disabled={!title || status === "uploading"}
                    onClick={handleSubmit}
                >
                    Upload
                </button>
            </div>

            {status === "success" && (
                <p className="text-sm text-green-600">
                    File uploaded successfully!
                </p>
            )}

            {status === "error" && (
                <p className="text-sm text-red-600">
                    Upload failed. Please try again.
                </p>
            )}

        </>
    );
}

export default FileUploader;